import csp from './csp';

const appConfig = {
  csp,
  provideStateConfig: {
    rootTenantUrl: {
      client: {
        e1: 'https://consumerpaymentuplift-deveusw1.americanexpress.com',
        e2: 'https://consumerpaymentuplift-qaeusw1.americanexpress.com',
        e3: 'https://consumerpaymentuplift-euse1.americanexpress.com',
      },
      server: {
        e1: 'https://consumerpaymentuplift-deveusw1.americanexpress.com',
        e2: 'https://consumerpaymentuplift-qaeusw1.americanexpress.com',
        e3: 'https://consumerpaymentuplift-euse1.americanexpress.com',
      },
    },
    OneLoginUrl: {
      client: {
        e1: 'https://oneamex:flower1@one-dev.americanexpress.com/en-us/account/peer-payments/login',
        e2: 'https://oneamex:flower1@qwww.americanexpress.com/en-us/account/peer-payments/login',
        e3: 'https://www.americanexpress.com/en-us/account/peer-payments/login',
      },
      server: {
        e1: 'https://one-dev.americanexpress.com/en-us/account/peer-payments/login',
        e2: 'https://qwww.americanexpress.com/en-us/account/peer-payments/login',
        e3: 'https://www.americanexpress.com/en-us/account/peer-payments/login',
      },
    },
    OneLoginEnrollmentUrl: {
      client: {
        e1: 'https://oneamex:flower1@one-dev.americanexpress.com/en-us/account/light/login',
        e2: 'https://oneamex:flower1@qwww.americanexpress.com/en-us/account/light/login',
        e3: 'https://www.americanexpress.com/en-us/account/light/login',
      },
      server: {
        e1: 'https://oneamex:flower1@one-dev.americanexpress.com/en-us/account/light/login',
        e2: 'https://oneamex:flower1@qwww.americanexpress.com/en-us/account/light/login',
        e3: 'https://www.americanexpress.com/en-us/account/light/login',
      },
    },
    p2pApiUrl: {
      client: {
        e1: 'https://dpp2ppartner-dev.americanexpress.com/payments/digital/v1/p2p',
        e2: 'https://dpp2ppartner-qaeusw1.americanexpress.com/payments/digital/v1/p2p',
        e3: 'https://dpp2ppartner.americanexpress.com/payments/digital/v1/p2p',
      },
      server: {
        e1: 'https://dpp2ppartner-dev.americanexpress.com/payments/digital/v1/p2p',
        e2: 'https://dpp2ppartner-qaeusw1.americanexpress.com/payments/digital/v1/p2p',
        e3: 'https://dpp2ppartner.americanexpress.com/payments/digital/v1/p2p',
      },
    },
    inAuth: {
      client: {
        e1: 'https://staging.cdn-net.com',
        e2: 'https://staging.cdn-net.com',
        e3: 'https://www.cdn-path.com',
      },
      server: {
        e1: 'https://staging.cdn-net.com',
        e2: 'https://staging.cdn-net.com',
        e3: 'https://www.cdn-path.com',
      },
    },
    GemUrl: {
      client: {
        e1: 'https://dicm.intra.aexp.com/Internet/IMDC/p2p',
        e2: 'https://qicm.americanexpress.com/Internet/IMDC/p2p',
        e3: 'https://origin-gemapp.americanexpress.com/Internet/IMDC/p2p',
      },
      server: {
        e1: 'https://dicm.intra.aexp.com/Internet/IMDC/p2p',
        e2: 'https://qicm.americanexpress.com/Internet/IMDC/p2p',
        e3: 'https://origin-gemapp.americanexpress.com/Internet/IMDC/p2p',
      },
    },
    PaypalRedirectUri: {
      client: {
        e1: 'https://www.amex.stage.paypal.com/myaccount/money/accounts/link',
        e2: 'https://www.amex.stage.paypal.com/myaccount/money/accounts/link',
        e3: 'https://www.paypal.com/myaccount/money/accounts/link',
      },
      server: {
        e1: 'https://www.amex.stage.paypal.com/myaccount/money/accounts/link',
        e2: 'https://www.amex.stage.paypal.com/myaccount/money/accounts/link',
        e3: 'https://www.paypal.com/myaccount/money/accounts/link',
      },
    },
    MycaRedirectUri: {
      client: {
        e1: 'https://e1qglobal.americanexpress.com/dashboard',
        e2: 'https://e2qglobal.americanexpress.com/dashboard',
        e3: 'https://global.americanexpress.com/dashboard',
      },
      server: {
        e1: 'https://e1qglobal.americanexpress.com/dashboard',
        e2: 'https://e2qglobal.americanexpress.com/dashboard',
        e3: 'https://global.americanexpress.com/dashboard',
      },
    },
    TIMEOUT: {
      client: {
        e1: 21000,
        e2: 21000,
        e3: 10000,
      },
      server: {
        e1: 21000,
        e2: 21000,
        e3: 10000,
      },
    },
  },
};

export default appConfig;
